import { logger } from "@gf/gf-logger";
import constants from '../../../common/services/informationDigest/constants';
import InformationDigestService from "../../../common/InformationDigestService";

export default {
    async load(params) {
        logger.logInfo("Loading TotalSleep metric", params);

        const result = await InformationDigestService.getEventCampaignDigestSummary(
            params.eid,
            params.bid,
            [constants.DIGEST_TYPE_ACTIVITY]
        );

        if (result && result.DigestSummaryEntries && result.DigestSummaryEntries.length > 0) {
            const sleepEntry = result.DigestSummaryEntries.find(x => x.Title === "TotalSleep");

            if (sleepEntry) {
                const totalSeconds = parseFloat(sleepEntry.Description);

                const totalHours = !isNaN(totalSeconds) ? totalSeconds / 3600 : 0;

                const targetSeconds = sleepEntry.AdditionalProperties && sleepEntry.AdditionalProperties.SleepTarget
                    ? parseFloat(sleepEntry.AdditionalProperties.SleepTarget)
                    : 0;
                const targetHours = !isNaN(targetSeconds) ? targetSeconds / 3600 : 0;

                logger.logInfo("TotalSleep metric loaded", { totalHours, targetHours });

                return {
                    Total: totalHours,
                    Target: targetHours
                };
            }
        }

        logger.logInfo("No TotalSleep data found, returning defaults");

        return {
            Total: 0,
            Target: 0
        };
    }
}
